import { detailsBigCss, detailsSmallCss } from "@/styles/typography";
import styled, { css } from "styled-components";

const colors: { [key: string]: any } = {
  blue: '#124d60',
  green: '#316558',
  red: '#CB2424',
  orange: '#af622b'
}

const stickyStyles = css`
  word-break: break-all;
`;

export const StyledDefaultButtonDark = styled.a<{ background?: string, sticky?: boolean, mixed?: boolean }>`
  ${detailsBigCss}
  ${stickyStyles}

  font-weight:  ${({ sticky }) => sticky ? '400' : '700'};
  font-family:  ${({ sticky }) => sticky ? 'Avenir Next' : 'Avenir Next Bold'};
  min-width: ${({ sticky }) => sticky ? 'fit-content' : ''};
  
  font-size:  ${({ sticky }) => sticky ? '16px' : ''};
  padding: ${({ sticky }) => sticky ? '8px 23px' : '20px 48px 16px 48px'};
  padding-top: ${({ mixed }) => mixed ? '2rem' : ''};
  position: ${({ mixed }) => mixed ? 'relative' : ''};

  .arrow_btn-active {
    display: none;
  }

  &:hover {
    .arrow_btn-active {
      display: block;
    }
    .arrow_btn {
      display: none;
    }
  }

  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: fit-content;
  color: ${({ theme }) => theme.textColors.secondary};
  border: ${({ theme, background }) => background ? colors[background] : theme.colors.primary} 2px solid;
  background: ${({ theme, background }) => background ? colors[background] : theme.colors.primary};
  text-decoration: none;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  white-space: ${({ sticky }) => sticky ? 'break-spaces' : 'nowrap'};
  text-align:  ${({ sticky }) => sticky ? 'start' : 'center'};;

  .arrow_btn-active {
    display: none;
  }

  &:hover {
    .arrow_btn-active {
      display: block;
    }
    .arrow_btn {
      display: none;
    }
  }

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      background-color: white;
      color: ${({ theme }) => theme.colors.primary};
      border: 2px solid ${({ theme }) => theme.colors.primary};
    }
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    ${detailsSmallCss}
    height: 46px;
    max-width: 100%;
    width: 100%;

    &:hover {
      color: ${({ theme }) => theme.textColors.secondary};
      border: ${({ theme }) => theme.colors.primary} 2px solid;
      background: ${({ theme }) => theme.colors.primary};
    }
  }
`;
